import React, { useCallback, useEffect, useState } from 'react';
import css from './styles.module.scss';
import { useHeaderColorChanger } from '~/utils/hooks/useHeaderColorChanger';
import * as variables from '~/styles/variables.scss';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { getCreatorsListThunk } from '~/features/creators-list/store/actions.thunks';
import { useSelector } from 'react-redux';
import { selectCreatorsList } from '~/features/creators-list/store/selectors';
import { CreatorRow } from '~/features/creators-list/components/creator-row';
import { Loader } from '~/common/loader';
import { IconButton, Typography } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { DownloadButton } from '~/common/download-button';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { orderBy } from 'lodash';

interface CreatorsListProps {
    totalRows?: number;

    userID?: number;

    firstName?: string;

    lastName?: string;

    email?: string;
    creators?: CreatorListItem[];
}

interface CreatorListItem {
    projectId?: number;

    projectCode?: string;

    projectOwner?: string | null;

    projectName?: string;

    creatorName?: string;

    addressLine1?: string;

    addressLine2?: string;

    addressLine3?: string;

    addressLine4?: string;

    addressNumber?: string;

    addressPostCode?: string;

    telephone?: string;

    ContactType?: string;

    creatorImage?: string;
}

interface CreatorsListPageProps {}

export const CreatorsListPage: React.FC<CreatorsListPageProps> = () => {
    const [isLoading, setIsLoading] = useState(true);

    useHeaderColorChanger(variables.colorOrange);
    const dispatch = useThunkDispatch();

    const creatorsListData = useSelector(selectCreatorsList);
    const [filterCreator, setFilterCreator] = useState(orderBy(creatorsListData?.creators, ['creators'], ['asc']));

    React.useEffect(() => {
        setFilterCreator(orderBy(creatorsListData?.creators, ['projectName'], ['asc']));
    }, [creatorsListData]);

    useEffect(() => {
        dispatch(getCreatorsListThunk()).finally(() => setIsLoading(false));
    }, [dispatch]);

    const handleSearch = (search: any) => {
        if (filterCreator && creatorsListData) {
            const searchFilteredCreator: any[] = creatorsListData?.creators.filter(
                creator =>
                    (creator.creatorName !== null ? creator.creatorName.toLowerCase() : '').includes(search.toLowerCase()) ||
                    (creator.projectName !== null ? creator.projectName.toLowerCase() : '').includes(search.toLowerCase()) ||
                    (creator.projectOwner !== null ? creator.projectOwner?.toLowerCase() : '').includes(search.toLowerCase())
            );

            setFilterCreator(searchFilteredCreator);
        }
    };

    const route = useAppRoute();
    const goToPreview = useCallback(() => route(`/creators-list/preview`), [route]);
    const goToSongPreview = useCallback(() => route(`/creators-list/song-preview`), [route]);

    return isLoading ? (
        <Loader />
    ) : (
        <>
            {creatorsListData?.creators && creatorsListData?.creators.length > 0 ? (
                <div className={`${css.module}`}>
                    <div className={css.searchSection}>
                        <InputBase
                            className={css.searchInput}
                            placeholder="Search here"
                            inputProps={{ 'aria-label': 'Search here' }}
                            onChange={(e: any) => handleSearch(e.target.value)}
                        />
                        <IconButton type="submit" className={css.searchButton} aria-label="search">
                            <SearchIcon />
                        </IconButton>
                        <DownloadButton className={css.actionSection} onClick={goToPreview} buttonFor="preview" title="Projects Export" />
                        <DownloadButton className={css.actionSection} color="blue" onClick={goToSongPreview} buttonFor="preview" title="Song Synch Status" />
                    </div>
                    <div className={`${css.dashboard_custom}`}>
                        {isLoading ? <Loader /> : filterCreator && true && filterCreator.map(item => <CreatorRow key={item.projectId} data={item} />)}
                    </div>
                </div>
            ) : (
                <div className={css.moduleNoCreator}>
                    <Typography variant="h6">No Creators available</Typography>
                </div>
            )}
        </>
    );
};
